import { InputBaseModel } from '../models';

export default class UiUtils {
    static shouldExpandCollapse(inputs: InputBaseModel[]) {
        return inputs.some(input => input.hasValue || input.required);
    }
}
